import React, { Component, useRef } from "react";

import { FeatureGroup, GeoJSON } from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import { withMapControl } from "../../../shared/containers/containerMapControl";
import LeafletRulerWrapper from "../../LeaflerRuler/LeafletRulerWrapper";
import "leaflet-draw/dist/leaflet.draw.css";
import "./leaflet-draw-custom.css";
import { createGeozone } from "../../LayerMapCotrol/services/geozoneHelper";
import { withWinterMaintence } from "../../../shared/containers/containerWinterMaintence";
import { v4 as uuidv4 } from "uuid";

const WinterMaintenceGeozoneSearch = (props) => {
  const { onSetGeozoneSearch, searchGeoZone, onSetWinterAreasFilter, winterAreasFilter } = props;
  const featureGroupRef = useRef();

  const onClearFeatureGroup = (e) => {
    if (featureGroupRef.current) {
      featureGroupRef.current.clearLayers();
    }

    onSetGeozoneSearch(null);
    onSetWinterAreasFilter(winterAreasFilter);
  };

  const onCreated = (e) => {
    const geometry = createGeozone(e.layer).geometry;
    onSetGeozoneSearch(geometry);
  };

  return (
    <div>
      <FeatureGroup ref={featureGroupRef}>
        <EditControl
          style={{ paddingTop: "100px!important" }}
          position="topleft"
          onDrawStart={onClearFeatureGroup}
          onCreated={onCreated}
          edit={{
            remove: false,
            edit: false,
          }}
          draw={{
            polyline: false,
            polygon: {
              showArea: true,
              showLength: true,
              precision: {
                km: 3,
              },
            },
            rectangle: {
              showArea: true,
            },
            circle: true,
            marker: false,
            circlemarker: false,
          }}
        ></EditControl>
        {searchGeoZone !== null ? <GeoJSON key={uuidv4()} data={JSON.parse(searchGeoZone)} /> : null}
      </FeatureGroup>

      {searchGeoZone !== null ? (
        <div class="leaflet-draw leaflet-control leaflet-draw-custom  leaflet-control-custom" onClick={onClearFeatureGroup}>
          <div class="leaflet-draw-section">
            <div class="leaflet-draw-toolbar leaflet-bar">
              <a class="leaflet-draw-edit-remove" href="#" title="Delete layers">
                <span class="sr-only">Delete layers</span>
              </a>
            </div>
            <ul class="leaflet-draw-actions"></ul>
          </div>
        </div>
      ) : null}

      <LeafletRulerWrapper />
    </div>
  );
};

export default withWinterMaintence(withMapControl(React.memo(WinterMaintenceGeozoneSearch)));
